<template>
  <div class="customer-profiling">
    <router-view />
  </div>
</template>

<script>
export default {
  setup() {},
};
</script>

<style lang="scss">
.customer-profiling {
  width: 100%;
  height: 100%;
  overflow: hidden;
}
</style>
